<template>
  <div>
    <b-table striped :items="badItems" small :fields="fields" :busy="loading">
        <template #thead-top="">
        <b-tr>
            <b-th colspan="2">
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">Fix Items</h5>
                    <b-button variant="outline-secondary" size="sm" @click="refreshBadItems">
                        <b-icon-arrow-counterclockwise></b-icon-arrow-counterclockwise>
                    </b-button>
                </div>
            </b-th>
        </b-tr>
        </template>

        <template #table-busy>
        <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="mx-3">Loading...</strong>
        </div>
        </template>

        <template #cell(count)="data">
          <b-link @click="navigateToInventory(data.item.type, data.item.itemIds)">{{ data.value }}</b-link>
        </template>
    </b-table>
  </div>
</template>

<script>
  import statsApi from "@/api/stats";  
  import utils from "@/mixins/utils";

  export default {
    name: 'BadItems',
    mixins: [ statsApi, utils ],
    data() {
      return {
        badItems: [],
        fields: [
          { key: 'type', label: 'Type'  },
          { key: 'count', label: 'Count'  },
        ],
        loading: false,
      }
    },
    methods: {
      navigateToInventory(type, itemIds) {
        if (!itemIds || itemIds.length === 0) {
          return;
        }
        
        const query = { 
          itemIds: itemIds.join(',')
        };

        this.$router.push({ name: 'inventory', params: { outsideQuery: { filters: query } } });
      },
      async getBadItems() {
        this.loading = true;

        try {
            const badItemsData = await this.fetchBadItems();
    
            this.badItems = [
              { type: 'Empty Genres', itemIds: badItemsData.emptyGenres || [], count: (badItemsData.emptyGenres || []).length },
              { type: 'Empty Formats', itemIds: badItemsData.emptyFormats || [], count: (badItemsData.emptyFormats || []).length },
              { type: 'Empty Durations', itemIds: badItemsData.emptyDurations || [], count: (badItemsData.emptyDurations || []).length },
              { type: 'Empty Speeds', itemIds: badItemsData.emptySpeeds || [], count: (badItemsData.emptySpeeds || []).length },
              { type: 'Empty Sizes', itemIds: badItemsData.emptySizes || [], count: (badItemsData.emptySizes || []).length },
              { type: 'Empty Grades', itemIds: badItemsData.emptyGrades || [], count: (badItemsData.emptyGrades || []).length },
              { type: 'Empty Title', itemIds: badItemsData.emptyTitle || [], count: (badItemsData.emptyTitle || []).length },
              { type: 'Empty Label', itemIds: badItemsData.emptyLabel || [], count: (badItemsData.emptyLabel || []).length },
              { type: 'Empty Artist', itemIds: badItemsData.emptyArtist || [], count: (badItemsData.emptyArtist || []).length },
            ].filter(item => item.count > 0);
        } catch (err) {
            this.showError(err, 'Fix Items');
        } finally {
            this.loading = false;
        }
      },
      async refreshBadItems() {
        this.loading = true;
        try {
          await this.refreshAllBadItems();
          await this.getBadItems();
        } catch (err) {
          this.showError(err, 'Fix Items');
        } finally {
          this.loading = false;
        }
      },
    },
    mounted() {
      this.getBadItems();
    }
  }
</script>

<style scoped>
  .table thead tr:first-child th {
    border-top: 0;
  }
</style>
